<template>
  <div class="md-layout md-size-100 md-small-size-100">
      <StatCardWithIcon
        v-for="card in this.submissionTabStats"
        :title="card.title" :value="card.value"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer">
      </StatCardWithIcon>
    </div>
</template>

<script>
import StatCardWithIcon from "./ReportingDashboard/components/StatCardWithIcon";

export default {
  components: {
    StatCardWithIcon
  },
  props: ['submissionTabStats'],
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
  }
}
</script>
<style>
</style>